export default __webpack_public_path__ + "static/aboutPng-85df375831f0a37c659fa4b8c6b668f8.png";